import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSocket } from "../../../helper/socket";

export const FetchleaderboardHistory = createAsyncThunk(
    "leaderboardHistory/fetch",
    async (payload , { rejectWithValue }) => {
        const { tournamentId  } = payload;
        return new Promise((resolve, reject) => {
            const socket = getSocket()
             try {
        // Emit event to request leaderboard
        socket.emit("getLeaderboard", payload.tournamentId, payload?.filterData );

        // Listen for response from server
        socket.on("leaderboardData", (response) => {
          if (response?.tournamentId == tournamentId) {
            resolve(response.leaderboard);
          } else {
            reject(rejectWithValue("Mismatched tournamentId"));
          }
        });

        
        // Handle timeout
        setTimeout(() => {
          reject(rejectWithValue("Timeout: No leaderboard data received."));
        }, 5000);
      } catch (error) {
        reject(rejectWithValue(error.message));
      }
        });
    }
);

const tournamentSocketSlice = createSlice({
    name: "leaderboardHistory",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
     reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(FetchleaderboardHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(FetchleaderboardHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(FetchleaderboardHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default tournamentSocketSlice.reducer;
